module.exports = "/images/py.svg?145354aeff41accfdc06cff94da623cf";